import { useMemo } from "react";

import { validatorRegistry, IField, IBuildSchemaArgs } from "./validatorRegistry";
import "./fieldTypes";
import "./fieldValidators";
import "./formValidators";

export function useYupSchema(args: IBuildSchemaArgs) {
  return useMemo(
    () => validatorRegistry.buildSchema(args),
    [args?.fields, args?.formValidators]
  );
}
